<template>
  <div style="padding-right: 30px">
    <el-form ref="form" :model="form" label-width="100px" :disabled="true">
      <el-form-item label="货源单号">
        <el-input v-model="form.mainOrderNumber" />
      </el-form-item>
      <el-form-item label="运输单号">
        <el-input v-model="form.orderCode" />
      </el-form-item>
      <el-form-item label="实际承运人姓名">
        <el-input v-model="form.driverName" />
      </el-form-item>
      <el-form-item label="实际承运人手机号">
        <el-input v-model="form.driverPhone" />
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input v-model="form.vehicleName" />
      </el-form-item>
      <el-form-item label="托运人名称">
        <el-input v-model="form.shipmentName" />
      </el-form-item>
      <el-form-item label="托运人手机号">
        <el-input v-model="form.shipmentPhone" />
      </el-form-item>
      <el-form-item label="地址">
        <el-input v-model="form.address" type="textarea" />
      </el-form-item>
      <el-form-item label="照片">
        <el-row>
          <el-col
            v-for="(item, i) in form.abnormalImageList"
            :key="i"
            :span="11"
            offset="1"
          >
            <el-image style="width: 100%" :src="item" />
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="投诉类型">
        <el-input v-model="form.abnormalTypeName" type="textarea" />
      </el-form-item>
      <el-form-item label="投诉说明">
        <el-input v-model="form.abnormalRemark" type="textarea" />
      </el-form-item>
      <el-form-item label="处理状态">
        <el-input v-model="form.formatterStatus" />
      </el-form-item>
      <el-form-item label="处理结果">
        <el-input v-model="form.handleIdea" type="textarea" />
      </el-form-item>
      <el-form-item label="满意度">
        <el-input v-model="form.satisfyStatus" />
      </el-form-item>
      <el-form-item label="结果反馈">
        <el-input v-model="form.abnormalFeedback" type="textarea" />
      </el-form-item>
      <el-form-item label="发生时间">
        <el-input v-model="form.occurrenceTime" />
      </el-form-item>
      <el-form-item label="处理时间">
        <el-input v-model="form.handleTime" />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  name: "Detail",
  data() {
    return {
      form: {},
      // 处理状态列表
      isHandleOptions: [
        { label: "待处理", value: 0 },
        { label: "已处理", value: 1 }
      ],
      //满意度列表
      isSatisfy: [{ label: "满意", value: 1 }, { label: "不满意", value: 2 }]
    };
  },
  methods: {
    getInfo(code) {
      request({
        url: `/ntocc-basic-api/orderDetailAbnormal/${code}`,
        method: "get"
      }).then(response => {
        this.form = response.data;
        //是否处理
        const item = this.isHandleOptions.find(
          item => item.value === this.form.isHandle
        );
        this.form.formatterStatus = item ? item.label : "";
        //满意度
        const item2 = this.isSatisfy.find(
          item2 => item2.value === this.form.satisfy
        );
        this.form.satisfyStatus = item2 ? item2.label : "";
        // this.$message({ message: response.msg, type: 'success' })
      });
    }
  }
};
</script>
